export default "__VITE_PUBLIC_ASSET__ae7f856c__"